import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActionConfirmationConfig } from '../../../shared/components/action-confirmation-modal/action-confirmation-modal.config';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-ghost-settlement-reclasses-delete',
    templateUrl: './ghost-settlement-reclasses-delete.component.html',
    styleUrls: ['./ghost-settlement-reclasses-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GhostSettlementReclassesDeleteComponent implements OnInit, OnDestroy {
  
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();
  private readonly subs = new Subscription();
  
  filterParams: any = {};
  globalParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  rowData: any = {};
  
  actionConfig: ActionConfirmationConfig | null = null;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.buildConfig();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.buildConfig();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.buildConfig();
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.filterParams = normalizeFilterParams(activeScreen) || {};
    this.rowData = rowPayloadFromActiveScreen(activeScreen) || {};
  }
  
  private buildConfig() {
    if (!this.GENERAL_CONFIG || !this.rowData || !Object.keys(this.rowData).length) {
      return;
    }

    this.actionConfig = {
      modalTitle: 'Delete Settlement Reclasses',
      confirmationMessage: '',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      showMinimize: false,
      successMessage: 'Settlement reclass was successfully deleted',
      errorMessagePrefix: 'Error deleting data',
      actionCode: 's3iych',
      contentType: 'urlencoded',
      responseFormat: 'callSuccess',
      payloadMapping: {
        'rp_seq_id': 'REC_SEQ_KEY'
      },
      baseUrl: this.GENERAL_CONFIG.base_url,
      globalParams: this.globalParams,
      filterParams: this.filterParams,
      rowData: this.rowData,
      ssoId: this.USER_SETTINGS?.user?.sso_id || '',
      refreshEventDetail: {}
    };
  }
  
  onConfirmed() {
    this.requestGridUpdate.emit('refresh');
  }
  
  onCancelled() {
    this.requestGridUpdate.emit('cancel');
  }
  
  onClosed() {
    this.requestGridUpdate.emit('cancel');
  }
}

